import {useMemo} from "react";
import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {useAreaEffect} from "@/encounter/effect/AreaEffectHooks.ts";
import {numberedAreaEffects, tokenAreaEffectMarks} from "@/tabletop/effects/AreaEffectHighlights.ts";
import type {Visibility} from "@/tabletop/visibility/VisibilityModel.ts";
import {playerTokenVisibility} from "./PlayerTokenVisibility.ts";

/** Shared status/mark preparation; map visibility and initiative anonymity remain separate policies. */
export function useTokenPresentation(visibility?: Visibility) {
    const {combatants} = useCombatants();
    const {effects} = useAreaEffect();
    const {dungeonSettings: {levelId}} = useDungeon();
    return useMemo(() => {
        const numbered = numberedAreaEffects(effects, combatants, levelId);
        const onLevel = combatants.filter(actor => actor.levelId === levelId);
        const marks = Object.fromEntries(onLevel.map(actor => [actor.id, tokenAreaEffectMarks(numbered, combatants, actor)]));
        const statuses = new Map(onLevel.map(actor => [actor.id, playerTokenVisibility(actor, visibility)]));
        const outsideSightIds = onLevel.filter(actor => statuses.get(actor.id)?.outsideSight).map(actor => actor.id);
        return {marks, statuses, outsideSightIds};
    }, [combatants, effects, levelId, visibility]);
}
